import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const Medicalbillingsys = () => {
  return (
    <MDBContainer fluid className="p-0">
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="section-title mb-4 pb-2">
              <h1 className="title mb-4 AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}>
                Medical Billing Services in USA – End-to-End RCM & Denial Management
              </h1>

                       <h2  className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold' }}>Medical Billing Services in USA</h2>

              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                 AcerHealth provides end-to-end medical billing services in the USA designed to help clinics and physician practices reduce claim denials, accelerate reimbursements, and strengthen 
                <a
                  href="https://acerhealth.com/blog/revenue-cycle-management-explained"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                >
                  revenue cycle performance.
                </a>
           We manage the complete 
             <a
                  href="https://acerhealth.com/blog/medical-billing-process"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                >
                medical billing process
                </a>—from insurance verification and claim submission to payment posting and follow-up—so providers can focus on patient care instead of administrative complexity. </p>


              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
               As a trusted medical billing outsourcing company in the USA, AcerHealth works across major U.S. payers, EHR/EMR systems, and specialties. Our approach improves first-pass claim rates, 
               lowers A/R days, and ensures full HIPAA-compliant billing operations tailored to each practice.
              </p>
      
              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                <b>Outcomes we deliver:</b>
              </p>
             

                    <ul style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>


                        <li style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>
                            Higher clean-claim rates
                        </li>
                        <li style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>
                           Faster reimbursements
                        </li>
                        <li style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>
                            Lower denial volumes
                        </li>
                        <li style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>
                            Transparent RCM reporting
                        </li>
                        <li style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", textAlign: "justify", marginBottom: "8px" }}>
                            Reduced administrative cost
                        </li>
                    </ul>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};
export default Medicalbillingsys;
